<template>
  <div class="modal fade" id="alertModal" tabindex="-1" aria-labelledby="alertModal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false"
       ref="modal">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content bg-danger h-100 w-100">
        <div class="modal-body d-flex flex-column justify-content-center align-items-center">
          <div class="text-center">
            <i class="ki-duotone ki-notification-bing fs-7hx text-white me-4">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
            </i>
            <h1 class="text-white" v-html="title"></h1>
            <h2 class="text-white" v-html="description"></h2>
          </div>
        </div>
        <div class="w-100 text-center p-5">
          <button v-if="countdown > 0"
              type="button"
              class="btn btn-secondary"
              disabled>
            ({{countdown}})
          </button>
          <button v-else
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              aria-label="Close">
            Понял (-а)
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AlertModal',
  components: {

  },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    timer: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      countdown: this.timer,
      interval: null
    }
  },
  mounted() {
    const modalElement = this.$refs.modal
    modalElement.addEventListener('show.bs.modal', () => {
      this.startTimer()
    })
  },
  beforeUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
    const modalElement = this.$refs.modal
    modalElement.removeEventListener('show.bs.modal', this.startTimer)
  },
  methods: {
    startTimer() {
      this.countdown = this.timer
      if (this.interval) {
        clearInterval(this.interval)
      }
      this.interval = setInterval(() => {
        if (this.countdown === 0) {
          clearInterval(this.interval)
          this.countdown = 0
        } else {
          this.countdown = this.countdown - 1
        }
      }, 1000)
    }
  },
}
</script>

<style scoped>

</style>